import { CatalogsStore } from '../stores/catalogs';
import { addNotification } from './ui';
import { isValidLocalCompanyTypeDictionary } from '../settings';
import { IBodyListResponse, IGetApiResponseDictionaryType, apiManager } from '../REST';
import { IItemAPI, INewSelectApi, ISelect, NotificationType } from '../interfaces';
import { sortByName } from '../instruments';
import { tI } from '../translate';

export function cleanCatalogsStore(): void {
    const StoreInstance = CatalogsStore.getInstance();
    StoreInstance.cleanStore();
}
export enum UnitTypeValues {
    DATA = 'byte',
    SMS = 'sms',
    VOICE = 'sec',
}

function setCatalogsRateUnitTypeSelectStore(apiList: IBodyListResponse): void {
    if (apiList.dictionary) {
        const list =
            apiList.dictionary
                ?.find((i) => i.name === 'rate_unit_types')
                ?.items?.map((i) => ({
                    id: `${i.value}`,
                    unit: i.label,
                })) || [];

        const StoreInstance = CatalogsStore.getInstance();
        StoreInstance.setRateUnitTypeSelect(list);
    }
}
export async function getCatalogsRateUnitTypeSelect(): Promise<void> {
    const { resp } = await apiManager.getApi('GET_RATE_UNIT_TYPE_SELECT');
    resp && setCatalogsRateUnitTypeSelectStore(resp as IBodyListResponse);
}
function setCatalogsDataUnitTypeSelect(list: ISelect[]): void {
    const StoreInstance = CatalogsStore.getInstance();
    StoreInstance.setDataUnitTypeSelect(list);
}
export const getCatalogsDataUnitTypeSelectIndex = (unit: string): number => {
    const StoreInstance = CatalogsStore.getInstance();
    const list = StoreInstance.dataUnitTypeSelect;
    const index = list.findIndex((i) => i.id === unit);
    if (index === -1) {
        console.warn('Not found unit:', unit);
    }
    return index;
};

const getSelectFromDictionaryResp = (
    resp: IBodyListResponse,
    dictionaryType: IGetApiResponseDictionaryType,
): ISelect[] => {
    return (
        resp.dictionary
            ?.find((i) => i.name === dictionaryType)
            ?.items?.filter((i) => !!i.value)
            ?.map((i) => ({
                id: `${i.value}`,
                name: i.label || i.value,
                ...i,
            })) || []
    );
};

export async function getCatalogsDataUnitTypeSelect(): Promise<void> {
    const { resp, isError } = await apiManager.getApi('GET_DATA_UNIT_TYPE_SELECT');
    if (!isError) {
        setCatalogsDataUnitTypeSelect(getSelectFromDictionaryResp(resp as IBodyListResponse, 'data_unit_types'));
    }
}

function setCatalogsOriginalUnitTypeSelect(list: ISelect[]): void {
    const StoreInstance = CatalogsStore.getInstance();
    StoreInstance.setOriginalUnitTypeSelect(list);
}

export async function getCatalogsOriginalUnitTypeSelect(): Promise<void> {
    const { resp, isError } = await apiManager.getApi('GET_ORIGINAL_UNIT_TYPE_SELECT');

    if (!isError) {
        setCatalogsOriginalUnitTypeSelect(
            getSelectFromDictionaryResp(resp as IBodyListResponse, 'original_unit_types'),
        );
    }
}

export function getCatalogsOriginalUnitTypeTitle(unitType?: UnitTypeValues): string {
    if (typeof unitType === 'undefined') {
        return '';
    }
    const StoreInstance = CatalogsStore.getInstance();
    const list = StoreInstance.initOriginalUnitTypeList;
    const unit = list.find((i: ISelect) => i.id === unitType);
    if (typeof unit === 'undefined') {
        console.warn('Not found unitType:', unitType);
        return '';
    }
    if (unit.name) {
        return unit.name;
    } else {
        console.warn('Not found name for unitType:', unitType);
        return unitType;
    }
}
function setCatalogsRateListTypeSelect(list: ISelect[]) {
    const StoreInstance = CatalogsStore.getInstance();
    StoreInstance.setImportTypeSelect(list);
}
export async function getCatalogsRateListTypeSelect() {
    const { resp, isError } = await apiManager.getApi('GET_SALES_RATE_IMPORT_TYPE_SELECT');
    if (!isError) {
        setCatalogsRateListTypeSelect(getSelectFromDictionaryResp(resp as IBodyListResponse, 'data_import_types'));
    }
}

export function getDashboardGraphTitleByUnitType(unitType?: UnitTypeValues): string {
    switch (unitType) {
        case UnitTypeValues.DATA:
            return tI('by Data Usage');
        case UnitTypeValues.SMS:
            return tI('by Sms Usage');
        case UnitTypeValues.VOICE:
            return tI('by Voice Usage');
        default:
            return tI('by Data Usage');
    }
}

export const getUnitLabel = (unit = '', currency = 'Cur.'): string => {
    let viewCode;
    switch (unit) {
        case 'percent':
            viewCode = '%';
            break;
        case 'amount':
            viewCode = currency;
            break;
        default:
            viewCode = '????';
            break;
    }
    return viewCode;
};

type IShowValue = {
    currency?: string;
    unit?: string;
    value?: number | string;
};
export const showValueLabel = ({ currency, value, unit }: IShowValue): string | null => {
    return value ? `${value}\u00A0${getUnitLabel(unit, currency)}` : null;
};

type IGetUnitIdLabelProps = {
    unit: string | undefined | null;
    currency: string | undefined;
};
type IGetUnitIdLabel = {
    id: string | undefined;
    label: string | undefined;
};
export const getUnitIdLabel = ({ unit, currency = 'Cur.' }: IGetUnitIdLabelProps): IGetUnitIdLabel => {
    const unitValue: IGetUnitIdLabel = { id: undefined, label: undefined };
    switch (unit) {
        case 'percent':
            unitValue.label = '%';
            unitValue.id = '2';
            break;
        case 'amount':
            unitValue.label = currency;
            unitValue.id = '1';
            break;
        default:
            console.warn(`Unknown unit type: ${unit} , currency: ${currency}`);
            break;
    }
    return unitValue;
};

export const getUnitById = (id?: string): string | undefined => {
    return id ? (id === '2' ? 'percent' : 'amount') : undefined;
};

export function makeSelectList(apiList: IBodyListResponse, isOnlyAvailable?: boolean): ISelect[] {
    let data = apiList?.data;

    if (isOnlyAvailable) {
        data = data?.filter((i: IItemAPI) => !i.attributes.deleted_at);
    }

    return (
        data
            ?.map((i: IItemAPI) => {
                const item: ISelect = {
                    id: i.id,
                    name: i.attributes.name,
                };
                return item;
            })
            .sort(sortByName) || []
    );
}

export function makeNewSelectList(apiList: IBodyListResponse, param: string): ISelect[] {
    const resp = apiList as unknown as INewSelectApi;

    const data = resp?.[param];

    return (
        data
            ?.map((method: string) => {
                const item: ISelect = {
                    id: method,
                    name: method.replace(/_/g, ' ').replace(/\b\w/g, (l) => l.toUpperCase()),
                };
                return item;
            })
            .sort(sortByName) || []
    );
}

function setCatalogsCompanyTypeSelect(apiList: IBodyListResponse): void {
    const list = makeSelectList(apiList);
    if (isValidLocalCompanyTypeDictionary(list)) {
        const StoreInstance = CatalogsStore.getInstance();
        StoreInstance.setCompanyTypes(list);
    } else {
        console.error('Invalid Company Types Dictionary');
        addNotification({
            type: NotificationType.ERROR,
            message: `Invalid Company Types Dictionary`,
            duration: 0,
        });
    }
}

export async function getCatalogsCompanyTypeSelect(): Promise<void> {
    const { resp } = await apiManager.getApi('GET_COMPANY_TYPES_SELECT');
    resp && setCatalogsCompanyTypeSelect(resp as IBodyListResponse);
}

function setCatalogsPaymentTypeSelect(apiList: IBodyListResponse): void {
    const StoreInstance = CatalogsStore.getInstance();
    StoreInstance.setPaymentTypes(makeNewSelectList(apiList, 'payment_methods'));
}

export async function getCatalogsPaymentTypeSelect(): Promise<void> {
    const { resp } = await apiManager.getApi('GET_PAYMENT_SELECT');
    resp && setCatalogsPaymentTypeSelect(resp as IBodyListResponse);
}

function setCatalogsOrderablesSelect(apiList: IBodyListResponse): void {
    const StoreInstance = CatalogsStore.getInstance();
    StoreInstance.setProductTypes(makeNewSelectList(apiList, 'orderables'));
}

export async function getCatalogsOrderablesSelect(): Promise<void> {
    const { resp } = await apiManager.getApi('GET_ORDER_ORDERABLES_SELECT');
    resp && setCatalogsOrderablesSelect(resp as IBodyListResponse);
}
